import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: "" as any,
  isVisible: false as boolean,
  isMadaVisible: false as boolean,
  data: null as any,
  amount: 0 as number,
};
export const hyperPaySlice = createSlice({
  name: "moyasar",
  initialState: initialState,
  reducers: {
    setType: (state, action) => {
      state.type = action.payload;
    },
    setIsVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setIsMadaVisible: (state, action) => {
      state.isMadaVisible = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setAmount: (state, action) => {
      state.amount = action.payload;
    },
  },
});
export const { setType, setIsVisible, setData, setAmount, setIsMadaVisible } =
  hyperPaySlice.actions;

export default hyperPaySlice.reducer;
